import NewProviderForm from './NewProviderForm';

export default NewProviderForm;
